import React, { useState, useEffect } from "react";
import MaterialTable from 'material-table'
import { ToastContainer, toast } from 'react-toastify';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import _ from "lodash";
import ContentLoader from "react-content-loader";

import { API } from "../../backend";
import authHeader from "../../services/auth-header";
import DeleteAddressService from "../../services/party/address/deleteAddressService";
import { getTrans as t } from "../../Localization/translations";
import PartyAddAddress from "../../Layouts/parties/components/address/Party-Add-Address";
import EditAddress from "../../Layouts/parties/components/address/editAddress";


function AddresstList({ id }) {
	const AddresstableRef = React.createRef();

	const [data, setData] = useState(id)
	const [loading, setLoading] = useState(true)
	const [hideshowedit, setHideShowEdit] = useState(false)
	const [addressid, setAddressID] = useState("");

	const handleEdit = (address_id) => {
		setAddressID(address_id)
		setHideShowEdit(true)
	}

	useEffect(() => {
		setLoading(false);
	}, []);

	const handelDelete = (id) => {
		confirmAlert({
			title: '',
			message: 'Are you sure you want to delete this Address?.',
			buttons: [
				{
					label: 'Yes',
					onClick: () => {
						DeleteAddressService.deleteAddress(id).then(
							(response) => {
								if (response.data.success) {
									toast.success(`${response.data.response}`, {
										position: "top-right",
										autoClose: 1000,
										hideProgressBar: false,
										pauseOnHover: true,
										draggable: true,
										progress: undefined,
										theme: "light",
									})
									AddresstableRef.current.onQueryChange()
								} else {
									toast.error(`${response.data.error}`, {
										position: "top-right",
										autoClose: 1000,
										hideProgressBar: false,
										pauseOnHover: true,
										draggable: true,
										progress: undefined,
										theme: "light",
									})
								}
							},
						)
					}
				},
				{
					label: 'No',
					onClick: () => alert('Click No')
				}
			]
		});
	}

	const handelActive = (id, status) => {
		confirmAlert({
			title: "",
			message:
				status === "Active"
					? "Are you sure you want to InActive this Address?."
					: "Are you sure you want to Active this Address?.",
			buttons: [
				{
					label: "Yes",
					onClick: () => {
						DeleteAddressService.ActiveAddress(id).then((response) => {
							if (response.data.success) {
								toast.success(`${response.data.response}`, {
									position: "top-right",
									autoClose: 1000,
									hideProgressBar: false,
									pauseOnHover: true,
									draggable: true,
									progress: undefined,
									theme: "light",
								});
								AddresstableRef.current.onQueryChange();
							} else {
								toast.error(`${response.data.error}`, {
									position: "top-right",
									autoClose: 1000,
									hideProgressBar: false,
									pauseOnHover: true,
									draggable: true,
									progress: undefined,
									theme: "light",
								});
							}
						})
					},
				},
				{
					label: "No",
				},
			],
		});
	};


	const handelInActive = (id, status) => {
		confirmAlert({
			title: "",
			message:
				status === "Active"
					? "Are you sure you want to InActive this Address?."
					: "Are you sure you want to Active this Address?.",
			buttons: [
				{
					label: "Yes",
					onClick: () => {
						DeleteAddressService.InActiveAddress(id).then((response) => {
							if (response.data.success) {
								toast.success(`${response.data.response}`, {
									position: "top-right",
									autoClose: 1000,
									hideProgressBar: false,
									pauseOnHover: true,
									draggable: true,
									progress: undefined,
									theme: "light",
								});
								AddresstableRef.current.onQueryChange();
							} else {
								toast.error(`${response.data.error}`, {
									position: "top-right",
									autoClose: 1000,
									hideProgressBar: false,
									pauseOnHover: true,
									draggable: true,
									progress: undefined,
									theme: "light",
								});
							}
						})
					},
				},
				{
					label: "No",
				},
			],
		});
	};


	const [hideshow, setHideShow] = useState(false)
	const hideshowstate = () => {
		setHideShow(true)
	}

	return (
		<>
			{
				hideshow === false ?
					hideshowedit === false ?
						<div className="row" >
							{
								loading === false ? (
									<>
										<ToastContainer />
										<div className="page-wrapper col-md-12 filter_contract">
											<div className=" mb-0">
												<div className="header pb-0">
													<div className="d-lg-flex mb-2">
														<div>
															<h5 className="mb-3" >{t('Manage Address')}</h5>
														</div>
														<div className="ms-auto my-auto mt-lg-0 mt-4">
															<div className="ms-auto my-auto">
																<div className="btn btn-primary  mb-0" onClick={hideshowstate} >+&nbsp;{t('New Address')}</div>
															</div>
														</div>
													</div>
												</div>
												<div className="body">
													<MaterialTable
														tableRef={AddresstableRef}
														style={{
															backgroundColor: "var(--bs-table-bg)",
															borderBottomWidth: "1px",
															boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
														}}
														columns={[
															{
																title: `${t("Address")}`,
																field: "address_line_1",
																render: rowData => <><div className="d-xl-none tc d-md-none d-lg-none">{t("Address")}</div><div>{rowData.address_line_1}</div></>,
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "left"
																},
																cellStyle: {
																	textAlign: "left",
																	fontSize: 12
																}
															},
															{
																title: `${t("City")}`,
																field: "city",
																render: rowData => <><div className="d-xl-none tc d-md-none d-lg-none">{t("City")}</div><div>{rowData.city}</div></>,
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "left"
																},
																cellStyle: {
																	textAlign: "left",
																	fontSize: 12
																}
															},
															{
																title: `${t("State")}`,
																field: "state",
																render: rowData => <><div className="d-xl-none tc d-md-none d-lg-none">{t("State")}</div><div>{rowData.state}</div></>,
																// export: false,
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "left"
																},
																cellStyle: {
																	textAlign: "left",
																	fontSize: 12
																}
															},
															{
																title: `${t("Zip Code")}`,
																field: "zip_code",
																render: rowData => <><div className="d-xl-none tc d-md-none d-lg-none">{t("Zip Code")}</div><div>{rowData.zip_code}</div></>,
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "left"
																},
																cellStyle: {
																	textAlign: "left",
																	fontSize: 12
																}
															},
															{
																title: `${t("Country")}`,
																field: "country",
																render: rowData => <><div className="d-xl-none tc d-md-none d-lg-none">{t("Country")}</div><div>{rowData.country}</div></>,
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "left"
																},
																cellStyle: {
																	textAlign: "left",
																	fontSize: 12
																}
															},
															{
																title: `${t("Bill To")}`,
																field: "bill_to",
																render: rowData => <><div className="d-xl-none tc d-md-none d-lg-none">{t("Bill To")}</div><div>{rowData.bill_to ? rowData.bill_to : "None"}</div></>,
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "left"
																},
																cellStyle: {
																	textAlign: "left",
																	fontSize: 12
																}
															},
															{
																title: `${t("Ship To")}`,
																field: "ship_to",
																render: rowData => <><div className="d-xl-none tc d-md-none d-lg-none">{t("Ship To")}</div><div>{rowData.ship_to ? rowData.ship_to : "None"}</div></>,
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "left"
																},
																cellStyle: {
																	textAlign: "left",
																	fontSize: 12
																}
															},
															{
																title: `${t("Install At")}`,
																field: "install_to",
																render: rowData => <><div className="d-xl-none tc d-md-none d-lg-none">{t("Install At")}</div><div>{rowData.install_to ? rowData.install_to : "None"}</div></>,
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "left"
																},
																cellStyle: {
																	textAlign: "left",
																	fontSize: 12
																}
															},
															{
																title: `${t("Address Reference")}`,
																field: "address_ref",
																render: rowData => <><div className="d-xl-none tc d-md-none d-lg-none">{t("Address Reference")}</div><div>{rowData.address_ref ? rowData.address_ref : "None"}</div></>,
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "left"
																},
																cellStyle: {
																	textAlign: "left",
																	fontSize: 12
																}
															},
															{
																title: `${t("Status")}`,
																field: "status",
																render: rowData => <><div className="d-xl-none tc d-md-none d-lg-none">{t("Status")}</div><div>{rowData.status ? rowData.status : "None"}</div></>,
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "left"
																},
																cellStyle: {
																	textAlign: "left",
																	fontSize: 12
																}
															},
														]}
														data={query =>
															new Promise((resolve, reject) => {
																const { orderBy, orderDirection } = query;

																let url = API + "parties/manage-address/" + id + "/?"
																url += 'per_page=' + query.pageSize
																url += '&page=' + (query.page + 1)
																url += '&search=' + query.search
																if (orderBy) {
																	url += `&orderBy=${orderBy.field}`;
																	url += `&orderDirection=${orderDirection}`;
																}
																fetch(url, { headers: authHeader() })
																	.then(response => response.json())
																	.then(result => {
																		resolve({
																			data: query.orderBy && query.orderDirection
																				? _.orderBy(
																					result.data,
																					[query.orderBy.field],
																					[query.orderDirection]
																				)
																				: result.data,
																			page: result.page - 1,
																			totalCount: result.total,
																		})
																	})
															})
														}
														actions={[
															{
																icon: () => <span ><img src={process.env.PUBLIC_URL + '/static/images/ic-edit.svg'} alt="Edit" /></span>,
																tooltip: "Edit",
																onClick: (event, rowData) => {
																	handleEdit(rowData.id)
																}
															},
															(rowData) => ({
																icon: rowData.status === "Active" ? "block" : "send",
																tooltip:
																	rowData.status === "Active"
																		? "InActivate"
																		: "Activate",
																onClick: (event, rowData) => {
																	rowData.status === "Active"
																		? handelInActive(rowData.id, rowData.status)
																		: handelActive(rowData.id, rowData.status);
																},
															}),
															(rowData) => ({
																icon: () => (
																	rowData.has_contract === true ? "" :
																		<img
																			src={
																				process.env.PUBLIC_URL +
																				"/static/images/ic-delete.svg"
																			}
																			alt="delete"
																		/>
																),
																tooltip: "Delete",
																hidden: rowData.has_contract === true ? true : false,
																onClick: (event, rowData) => {
																	handelDelete(rowData.id, rowData.status);
																},
																disabled:
																	rowData.has_contract === true ? true : false,
															}),
														]}
														options={{
															headerStyle: {
																backgroundColor: "white",
																color: "#245C7F",
																fontSize: 12,
															},
															rowStyle: (rowData, index) => {
																if (index % 2) {
																	return { backgroundColor: "#fff" }
																}
															},
															sorting: true,
															search: false,
															toolbar: false,
															paging: true,
															pageSize: 10,       // make initial page size
															emptyRowsWhenPaging: false,   // To avoid of having empty rows
															pageSizeOptions: [10, 15, 20, 50],
															paginationType: "stepped",
															showFirstLastPageButtons: false,
															actionsColumnIndex: -1,
														}}
													/>
												</div>
											</div>
										</div>
									</>
								) : (
									<ContentLoader
										viewBox="0 0 1000 550"
										backgroundColor="rgba(0,0,0,0.06)"
										foregroundColor="rgba(0,0,0,0.12)"
									>
										<rect x="51" y="45" rx="3" ry="3" width="906" height="17" />
										<circle cx="879" cy="123" r="11" />
										<circle cx="914" cy="123" r="11" />
										<rect x="104" y="115" rx="3" ry="3" width="141" height="15" />
										<rect x="305" y="114" rx="3" ry="3" width="299" height="15" />
										<rect x="661" y="114" rx="3" ry="3" width="141" height="15" />
										<rect x="55" y="155" rx="3" ry="3" width="897" height="2" />
										<circle cx="880" cy="184" r="11" />
										<circle cx="915" cy="184" r="11" />
										<rect x="105" y="176" rx="3" ry="3" width="141" height="15" />
										<rect x="306" y="175" rx="3" ry="3" width="299" height="15" />
										<rect x="662" y="175" rx="3" ry="3" width="141" height="15" />
										<rect x="56" y="216" rx="3" ry="3" width="897" height="2" />
										<circle cx="881" cy="242" r="11" />
										<circle cx="916" cy="242" r="11" />
										<rect x="106" y="234" rx="3" ry="3" width="141" height="15" />
										<rect x="307" y="233" rx="3" ry="3" width="299" height="15" />
										<rect x="663" y="233" rx="3" ry="3" width="141" height="15" />
										<rect x="57" y="274" rx="3" ry="3" width="897" height="2" />
										<circle cx="882" cy="303" r="11" />
										<circle cx="917" cy="303" r="11" />
										<rect x="107" y="295" rx="3" ry="3" width="141" height="15" />
										<rect x="308" y="294" rx="3" ry="3" width="299" height="15" />
										<rect x="664" y="294" rx="3" ry="3" width="141" height="15" />
										<rect x="58" y="335" rx="3" ry="3" width="897" height="2" />
										<circle cx="881" cy="363" r="11" />
										<circle cx="916" cy="363" r="11" />
										<rect x="106" y="355" rx="3" ry="3" width="141" height="15" />
										<rect x="307" y="354" rx="3" ry="3" width="299" height="15" />
										<rect x="663" y="354" rx="3" ry="3" width="141" height="15" />
										<rect x="57" y="395" rx="3" ry="3" width="897" height="2" />
										<circle cx="882" cy="424" r="11" />
										<circle cx="917" cy="424" r="11" />
										<rect x="107" y="416" rx="3" ry="3" width="141" height="15" />
										<rect x="308" y="415" rx="3" ry="3" width="299" height="15" />
										<rect x="664" y="415" rx="3" ry="3" width="141" height="15" />
										<rect x="55" y="453" rx="3" ry="3" width="897" height="2" />
										<rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
										<rect x="955" y="49" rx="3" ry="3" width="2" height="465" />
										<circle cx="882" cy="484" r="11" />
										<circle cx="917" cy="484" r="11" />
										<rect x="107" y="476" rx="3" ry="3" width="141" height="15" />
										<rect x="308" y="475" rx="3" ry="3" width="299" height="15" />
										<rect x="664" y="475" rx="3" ry="3" width="141" height="15" />
										<rect x="55" y="513" rx="3" ry="3" width="897" height="2" />
										<rect x="52" y="80" rx="3" ry="3" width="906" height="17" />
										<rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
										<rect x="222" y="54" rx="3" ry="3" width="149" height="33" />
										<rect x="544" y="55" rx="3" ry="3" width="137" height="33" />
										<rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
										<rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
									</ContentLoader>
								)
							}
						</div>
						:
						<EditAddress id={id} address={addressid} />
					:
					<PartyAddAddress id={data} />
			}
		</>
	)
}

export default AddresstList